<template>
  <div>
    <div class="bulk-update">
      <pageTabHeader>
        <h5>Bulk Update</h5>
      </pageTabHeader>
      <div class="content">
        <h6>Bulk Update</h6>
        <p class="body-1">
          Choose the operation you wish to perform on the selected
          {{ bulkUpdateCount }} client(s)
        </p>
        <radioGroup
          class="selection"
          :value="bulkUpdateMode"
          @change="setBulkUpdateMode"
        >
          <div class="option">
            <radio value="edit" />
            <p class="subtitle-2">Bulk Edit</p>
            <p class="subtitle-2">Edit field values</p>
          </div>
          <div class="option">
            <radio value="delete" />
            <p class="subtitle-2">Bulk Delete</p>
            <p class="subtitle-2">Clear field values</p>
          </div>
        </radioGroup>
      </div>
    </div>
    <bottomBar>
      <qvoButton text @click="cancel">Cancel</qvoButton>
      <qvoButton :disabled="!bulkUpdateMode" @click="goToNextStep"
        >Next</qvoButton
      >
    </bottomBar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import bottomBar from "@/components/bottom-bar";
import pageTabHeader from "@/components/page-tab-header";
import radio from "@/qux-common/qux22/components/molecules/radio";
import radioGroup from "@/qux-common/qux22/components/molecules/radio-group";
import qvoButton from "@/qux-common/qux22/components/molecules/button";

export default {
  name: "BulkUpdate",
  components: {
    bottomBar,
    pageTabHeader,
    radio,
    radioGroup,
    qvoButton,
  },
  computed: {
    ...mapGetters({
      bulkUpdateCount: "getBulkUpdateCount",
      bulkUpdateMode: "getBulkUpdateMode",
    }),
  },
  methods: {
    setBulkUpdateMode(mode) {
      this.$store.dispatch("bulkUpdateMode", mode);
    },
    cancel() {
      this.$router.push("/clients");
    },
    goToNextStep() {
      this.$router.push(
        this.bulkUpdateMode === "edit"
          ? "/clients/bulkEdit"
          : "/clients/bulkDelete"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.page-tab-header {
  flex-direction: column;
}
.bulk-update {
  height: calc(100% - 74px);
}
.content {
  padding: $qvo-spacing-24;
  max-width: 960px;
  margin: auto;
  h6 {
    padding-bottom: 12px;
  }
}
.selection {
  padding-top: $qvo-spacing-48;
  .option {
    padding: $qvo-spacing-24 0 $qvo-spacing-16;
    display: grid;
    grid-template-columns: min-content 1fr 1fr;
    gap: 24px;
    align-items: center;
    border-bottom: 1px solid $qvo-color-grey-200;
    p {
      margin-bottom: $qvo-spacing-8;
    }
  }
}
</style>